import { IBrand } from "@faire/web-api/indigofair/data/IBrand";
import { IProduct } from "@faire/web-api/indigofair/data/IProduct";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web/common/localization/localize";
import { trackEvent } from "@faire/web/common/trackEvent";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { trackProductClick } from "@faire/retailer/services/Events";
import { MaxWidthContainer } from "@faire/retailer/views/video/components/layout";
import { ProductGrid } from "@faire/retailer/views/video/FeaturedProducts/ProductGrid";

interface IProps {
  brand: IBrand;
  products: IProduct[];
}

export const FeaturedProducts: React.FC<IProps> = ({ brand, products }) => {
  const { isMobile } = useViewport();
  const handleProductClick = (token: string) => {
    trackEvent(`video/featured-products/${token}/click`);
    trackProductClick(token, "brand_video_page_featured_products");
  };

  if (!products.length) {
    return null;
  }

  return (
    <Container>
      <Typography
        variant={isMobile ? "pageHeaderSerifRegular" : "displaySSerifRegular"}
      >
        <StrictLocalMsg
          defaultMessage="{count, plural, one{Featured product from {brandName}} other{Featured products from {brandName}}}"
          values={DEPRECATED_backwardsCompatibleValues({
            brandName: brand.name,
            count: products.length,
          })}
        />
      </Typography>
      <Spacer size="4x" />
      <ProductGrid
        products={products}
        trackProductClickEvent={handleProductClick}
        solidTile
      />
    </Container>
  );
};

const Container = styled(MaxWidthContainer)`
  padding-bottom: 40px;
`;
